import _memoize from 'lodash/memoize';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { PRIMARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../../tornado/utils/sizes';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const PADDING_TOP = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const GAP = {
  [HD]: 40,
  [FULL_HD]: 40,
};

export const PADDING_RIGHT = {
  [HD]: 80,
  [FULL_HD]: 104,
};

export const PADDING_LEFT = {
  [HD]: 80,
  [FULL_HD]: 104,
};

export const WIDTH = {
  [HD]: 640,
  [FULL_HD]: 960,
};

export const TEXT_WIDTH = {
  [HD]: WIDTH[HD] - PADDING_RIGHT[HD] - PADDING_LEFT[HD],
  [FULL_HD]: WIDTH[FULL_HD] - PADDING_RIGHT[FULL_HD] - PADDING_LEFT[FULL_HD],
};

export const colors = {
  text: makeThemeColor(PRIMARY),
  backgroundOverlay: makeThemeColor(PRIMARY, 0.1),
  background: makeThemeColor(TERTIARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const offsetX = SCREEN_WIDTH[screenSize] + WIDTH[screenSize];
  const color = colors.text[colorMode];
  const titleFont = getFont(FONT.TOKYO_4, screenSize);
  const textWidth = TEXT_WIDTH[screenSize];

  return {
    visible: false,
    x: offsetX,
    w: WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    color: colors.background[colorMode],
    BackgroundOverlay: {
      w: WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      color: colors.backgroundOverlay[colorMode],
    },
    Title: {
      x: PADDING_LEFT[screenSize],
      y: PADDING_TOP[screenSize],
      text: {
        ...titleFont,
        wordWrapWidth: textWidth,
        textColor: color,
        verticalAlign: 'bottom',
        maxLinesSuffix: '...',
        maxLines: 2,
      },
    },
    Scroll: {
      visible: false,
      x: PADDING_LEFT[screenSize],
      w: textWidth,
    },
  };
};

export const getFocusedStyle = _memoize(screenSize => ({
  visible: true,
  smooth: {
    x: SCREEN_WIDTH[screenSize] - WIDTH[screenSize],
  },
}));

export const getUnFocusedStyle = _memoize(screenSize => ({
  smooth: {
    x: SCREEN_WIDTH[screenSize],
  },
}));
